import React from 'react';

import { RouteInfoData, TrainDetails } from '../types';

export type onTrainExtraClickedType = {
  isMobile: boolean;
  fromCityEn: string;
  toCityEn: string;
  fromCity: string;
  fromStn: string;
  toCity: string;
  toStn: string;
  trainNumber: string;
};
interface RouteInfoContext extends RouteInfoData {
  onTrainClicked: (TrainDetails: TrainDetails) => void;
  onTrainExtraSectionClicked: (config: onTrainExtraClickedType) => void;
}

// https://github.com/typescript-cheatsheets/react-typescript-cheatsheet#context
const RouteInfoContext = React.createContext({} as RouteInfoContext);

export default RouteInfoContext;
